import React from "react";

/**
 * DuunariPhone — Left phone. Worker's Päivä (Day) view: hours today, entries, add-button.
 */
export const DuunariPhone = () => {
  return (
    <PhoneFrame
      testId="phone-duunari"
      badge="DUUNARI"
      badgeSubtitle="Työntekijä"
    >
      <PhoneScreenshot
        src="/assets/img-duunari-day.webp"
        alt="Duunari-sovellus, työntekijän Päivä-näkymä: 8,0 h tehty, 1,0 km, työmaakirjaus"
      />
    </PhoneFrame>
  );
};

/**
 * PomoPhone — Right phone. Boss's Tiimi (Team) view: active plan, worker seats, invite button.
 */
export const PomoPhone = () => {
  return (
    <PhoneFrame testId="phone-pomo" badge="POMO" badgeSubtitle="Tiiminvetäjä">
      <PhoneScreenshot
        src="/assets/img-pomo-team.webp"
        alt="Pomo-sovellus, tiiminvetäjän Tiimi-näkymä: aktiivinen tilaus, työntekijäpaikat ja kutsu työntekijä -nappi"
      />
    </PhoneFrame>
  );
};

/* ---------- Shared subcomponents ---------- */

/** Real app screenshot filling the phone bezel. */
const PhoneScreenshot = ({ src, alt }) => (
  <img
    src={src}
    alt={alt}
    loading="lazy"
    decoding="async"
    className="absolute inset-0 w-full h-full object-cover object-top select-none pointer-events-none"
    draggable={false}
  />
);

const PhoneFrame = ({ children, testId, badge, badgeSubtitle }) => {
  return (
    <div
      data-testid={testId}
      className="relative mx-auto"
      style={{ width: 290 }}
    >
      {/* Label badge above phone */}
      <div className="absolute -top-9 left-1/2 -translate-x-1/2 z-20 whitespace-nowrap">
        <div className="bg-black border-2 border-[#FFEA00] px-3 py-1.5 flex items-center gap-2">
          <span className="w-1.5 h-1.5 bg-[#FFEA00] rounded-full pulse-dot" />
          <span className="font-display font-bold text-white text-xs tracking-widest uppercase">
            {badge}
          </span>
          <span className="font-mono text-[9px] text-[#A3A3A3]">
            · {badgeSubtitle}
          </span>
        </div>
      </div>

      {/* Neon yellow aura behind phone */}
      <div className="phone-aura" aria-hidden="true" />

      {/* Outer rugged case */}
      <div
        className="relative bg-[#1a1a1a] p-3 border-2 border-[#2a2a2a]"
        style={{
          borderRadius: 38,
          boxShadow:
            "0 0 0 1px #0a0a0a inset, 0 30px 60px -20px rgba(0,0,0,0.85), 0 0 80px rgba(255,234,0,0.25), 0 0 140px rgba(255,234,0,0.12)",
        }}
      >
        {/* Side buttons */}
        <div className="absolute left-[-3px] top-20 w-[3px] h-10 bg-[#0a0a0a]" />
        <div className="absolute left-[-3px] top-36 w-[3px] h-16 bg-[#0a0a0a]" />
        <div className="absolute right-[-3px] top-28 w-[3px] h-20 bg-[#0a0a0a]" />

        {/* Bezel */}
        <div
          className="relative bg-black overflow-hidden"
          style={{ borderRadius: 28, height: 560 }}
        >
          {/* Notch */}
          <div className="absolute top-2 left-1/2 -translate-x-1/2 z-30 w-24 h-5 bg-black rounded-full flex items-center justify-end px-2 gap-1">
            <div className="w-1.5 h-1.5 bg-[#1a1a1a] rounded-full" />
            <div className="w-1 h-1 bg-[#1a1a1a] rounded-full" />
          </div>

          {/* Screen content */}
          <div className="relative w-full h-full">{children}</div>
        </div>

        {/* Bottom brand stripe */}
        <div className="absolute bottom-[-1px] left-1/2 -translate-x-1/2 w-16 h-[3px] bg-[#FFEA00]" />
      </div>
    </div>
  );
};
